import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import { Col, Row } from 'react-bootstrap'
import type { RouteDef } from '@ztechapps/common.contract'
import { LoadMoreButton } from '@ztechapps/webui.button'
import { WebuiIocKey, useInject } from '@ztechapps/webui.contract'
import { GridListViewModeEnum } from '@ztechapps/webui.data-tools'
import { DataSuspense, ShowIf } from '@ztechapps/webui.util'
import { BlogBox } from '../BlogBox'
import { useBlogListContext } from './Context'
import { ListView } from './ListView'

export const Layout = () => {
  const { list, error, loading, pageInfo, loadMoreEntries, sort, filter, viewMode } = useBlogListContext()
  const blogItemRoute = useInject<RouteDef>(WebuiIocKey.routes.blogItem)

  return (
    <DataSuspense {...{ loading, error, isEmpty: isEmpty(list) }}>
      {viewMode === GridListViewModeEnum.Grid ? (
        <Row className="g-3">
          {map(list, (blog) => (
            <Col key={blog?._id} md={4}>
              <BlogBox {...blog} linkToPath={blogItemRoute.altPath({ _id: blog?._id })} />
            </Col>
          ))}
        </Row>
      ) : (
        <ListView />
      )}
      <ShowIf condition={!error}>
        <LoadMoreButton {...{ dataArray: list, pageInfo, loadMoreEntries, loading, sort, filter }} />
      </ShowIf>
    </DataSuspense>
  )
}
